exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!../../../components/buttons.css"), "");

// module
exports.push([module.id, ".btn:empty:after,.btn:empty:before{position:absolute;content:\"\"}.btn_loop{height:44px;width:44px;display:block;background:rgba(0,0,0,.07);border-radius:2px;position:relative}.btn_loop:after,.btn_loop:before{content:\"\";display:block;position:absolute;top:0;left:0}.btn_loop:before{border-top:5px solid transparent;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #000;top:27px;left:20px}.btn_loop:after,.btn_loop:before{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}.btn_loop:after{height:20px;width:20px;border-radius:50%;border:1px solid #000;border-right-color:transparent;left:11px;top:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/buttons.css
// module id = 226
// module chunks = 0